import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  countryData: {},
  isLoading: false,
  error: "",
  hasData: false
};
const fetchCountryListSlice = createSlice({
  name: "countryList",
  initialState,
  reducers: {
    getCountryListRequest: state => {
      state.isLoading = true;
    },
    getCountryListSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.countryData = action?.payload;
    },
    getCountryListFailure: (state, action) => {
      state.isLoading = false;
      state.hasData = false;
      state.error = action?.payload?.response?.data;
      state.countryData = {};
    }
  }
});
export const {
  getCountryListRequest,
  getCountryListSuccess,
  getCountryListFailure
} = fetchCountryListSlice.actions;
export default fetchCountryListSlice.reducer;